<template>
  <div class="menu">
    <div class="row">
      <div class="col-md-12">
        <h2>Wat wilt u doen?</h2>
        <p>Welkom! U kunt de stichting op meerdere maniere steunen. Welke heeft uw voorkeur?</p>
      </div>
    </div>
    <div class="row">
      <div class="col-4 menu-item">
        <p>Ik wil graag een snelle eenmalige donatie doen aan de stichting.</p>
        <router-link :to="{ name: 'Donate_step1' }"><button>Snelle donatie</button></router-link>
      </div>
      <div class="col-4 menu-item">
        <p>Ik wil Vriend (donateur) worden van de stichting. </p>
        <router-link :to="{ name: 'Donator_step1' }"><button>Donateur worden</button></router-link>
      </div>
      <div class="col-4 menu-item">
        <p>Ik wil meer informatie over de stichting.</p>
        <router-link :to="{ name: 'About' }"><button>Meer informatie</button></router-link>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Menu.vue